import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let UserLoginLog = class UserLoginLog extends Vue {
};
UserLoginLog = __decorate([
    Component({
        name: 'Home'
    })
], UserLoginLog);
export default UserLoginLog;
;
